/* eslint-disable no-debugger */
import React, { Fragment, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router";
import {
  FilterIcon,
  ResetIcon,
  CaretUpSolidIcon,
  CaretDownSolidIcon,
  VideoIcon,
  ApproveIcon,
  Disapprove,
  CopyIcon,
} from "../../../assets/icons/index";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import DropDownComponent from "../questions/metadataDropDownList";
import { IStandard } from "../../../model/interface/standard";
import Loader from "../../shared/loader/loader";
import {
  getStandards,
  associateStandardQuestions,
  validateStandardQuestionAssociation,
} from "../../../api/standard.service";
import { getAllDomainsBySubject } from "../../../api/domain.service";
import { getAllQuestions } from "../../../api/question.service";
import { IQuestion, IQuestionSearch } from "../../../model/interface/question";
import constant from "../../../utils/constant";
import QuestionTypeSelect from "../questions/questionTypeSelect";
import { IReactSelect } from "../../../model/interface/keyValuePair";
import Tooltip from "../../shared/common/ellipsisText";
import TagSelector, { TagSelectorMode } from "../../shared/common/tagSelector";
import { TagColor } from "../../../model/tagColor";
import { useConfirmation } from "../../shared/confirmation/confirmationService";
import UgaItemIcon from "../../shared/common/ugaItemIcon";

function QuestionList() {
  const [pageSize, setPageSize] = useState(100);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [resetDropdownFlag, setResetDropdownFlag] = useState<boolean>(false);
  const [questionList, setQuestionList] = useState<IQuestion[]>([]);
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("questionId");
  const [loading, setLoading] = useState<boolean>(false);
  const [subjects, setSubjects] = useState([]);
  const [state, setState] = useState([]);
  const [domain, setDomain] = useState([]);
  const [standard, setStandard] = useState([]);
  const [questionTypeId, setQuestionTypeId] = useState<number>(0);
  const [stateId, setStateId] = useState(0);
  const [subjectId, setSubjectId] = useState<number>(0);
  const [domainId, setDomainId] = useState<number>(0);
  const [standardId, setStandardId] = useState<number>(0);
  const [questionId, setQuestionId] = useState<number>(0);
  const [dok, setDok] = useState<number>(0);
  const [tagId, setTagId] = useState<number>(0);
  const [isActive, setIsActive] = useState<boolean>(true);
  const [isPublished, setIsPublished] = useState<boolean>(true);
  const [isDiagnostics, setIsDiagnostics] = useState<boolean>(false);
  const navigate = useNavigate();
  const [enableDisableStates, setEnableDisableStates] = useState<boolean>(true);
  const [enableDisableSubjects, setEnableDisableSubjects] =
    useState<boolean>(true);
  const [enableDisableDomains, setEnableDisableDomains] =
    useState<boolean>(true);
  const [enableDisableStandards, setEnableDisableStandards] =
    useState<boolean>(true);
  const [filterQuestionId, setFilterQuestionId] = useState<number>();
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [isFilter, setIsFilter] = useState<boolean>(false);
  const [associateQuestions, setAssociateQuestions] = useState<Array<any>>([]);
  const [selectedStandard, setSelectedStandard] = useState<IReactSelect>();
  const [selectedSubject, setSelectedSubject] = useState<IReactSelect>();
  const [selectedDomain, setSelectedDomain] = useState<IReactSelect>();
  const location = useLocation();
  const parameters = location.state as any;
  const [filterClicked, setFilterClicked] = useState<boolean>(false);
  const [selectedTagIds, setSelectedTagIds] = useState<Array<number>>([]);
  const [isReset, setIsResetFlag] = useState<boolean>(false);
  const [isInitialLoad, setIsInitialLoad] = useState<boolean>(true);
  const confirm = useConfirmation();
  function resetFilterHandler() {
    setFilterClicked(false);
    setResetDropdownFlag(!resetDropdownFlag);
    setQuestionId(0);
    setQuestionTypeId(0);
    setStateId(0);
    setSubjectId(0);
    setDomainId(0);
    setStandardId(0);
    setDok(0);
    setTagId(0);
    setIsActive(true);
    setIsPublished(true);
    setIsDiagnostics(false);
    setOrderByColumn("questionId");
    setSortAscending(true);
    setEnableDisableStates(true);
    setEnableDisableSubjects(true);
    setEnableDisableDomains(true);
    setEnableDisableStandards(true);
    setSelectedStandard({ label: "", value: 0 });
    setSelectedDomain({ label: "", value: 0 });
    setSelectedSubject({ label: "", value: 0 });
    setSelectedTagIds([]);
    setIsResetFlag(true);
    setQuestionList([]);
    paginationRef?.current?.onReset();
    pageSizeRef?.current?.onReset();
    setTimeout(() => {
      setResetDropdownFlag(false);
    }, 1500);
    setFilterQuestionId(0);
    for (let i = 0; i < associateQuestions.length; i++) {
      const elem: any = document.getElementById(`${associateQuestions[i]}`);
      if (elem) elem.checked = false;
    }
    setTimeout(() => {
      setAssociateQuestions([]);
    });
  }

  const bindQuestionListWithPageCheck = (
    filter: IQuestionSearch,
    onFilter?
  ) => {
    setLoading(true);
    getAllQuestions(filter).then((response: any) => {
      setLoading(false);
      setIsLoaded(true);
      const pageCount = Math.ceil(response.data.totalRecords / pageSize);
      if (pageNumber > pageCount && pageNumber > 1) {
        setPageNumber(1);
      } else {
        setQuestionList(response.data.data);
        setTotalPages(pageCount);
        setTotalRecords(response.data.totalRecords);
      }

      if (onFilter) {
        paginationRef?.current?.onReset();
        pageSizeRef?.current?.onReset();
        setIsFilter(false);
      }
    });
  };

  function bindQuestionList(onFilter?) {
    setIsResetFlag(false);
    if (onFilter) setIsFilter(true);
    let questionData: IQuestionSearch = {};
    if (filterClicked || onFilter) {
      questionData = {
        questionTypeId: questionTypeId,
        stateId: stateId,
        subjectId: subjectId,
        domainId: domainId,
        standardId: standardId,
        dok: dok,
        tagId: tagId,
        isPublished: isPublished,
        isDiagnostics: isDiagnostics,
        isActive: isActive,
        orderbyColumn: orderByColumn,
        sortDir: sortAscending ? "ASC" : "DESC",
        pageSize: onFilter ? 100 : pageSize,
        pageNumber: onFilter ? 1 : pageNumber,
        tagIds: selectedTagIds.toString(),
      };
    } else {
      questionData = {
        questionTypeId: 0,
        stateId: 0,
        subjectId: 0,
        domainId: 0,
        standardId: 0,
        dok: 0,
        tagId: 0,
        isPublished: true,
        isDiagnostics: false,
        isActive: true,
        orderbyColumn: orderByColumn,
        sortDir: sortAscending ? "ASC" : "DESC",
        pageSize: pageSize,
        pageNumber: pageNumber,
      };
    }

    if (filterQuestionId) {
      questionData.questionId = filterQuestionId;
    }
    setIsInitialLoad(false);
    bindQuestionListWithPageCheck(questionData, onFilter);
  }

  function handleDomainChange(selectedItem: any) {
    setDomainId(selectedItem);
  }

  function handleStandardChange(selectedItem: any) {
    setStandardId(selectedItem);
  }

  function handleQuestionTypeChange(selectedItem: any) {
    setQuestionTypeId(selectedItem.value);
    if (selectedItem.value > 0) setEnableDisableStates(false);
  }

  function handleStateChange(selectedItem: any) {
    setStateId(selectedItem);
  }

  function handleSubjectChange(selectedItem: any) {
    setSubjectId(selectedItem);
    setDomainId(0);
    setStandardId(0);
    setSelectedStandard({ label: "", value: 0 });
    setSelectedDomain({ label: "", value: 0 });
  }
  function handleDOKChange(selectedItem: any) {
    setDok(selectedItem);
  }

  const editHandler = (questionId) => {
    navigate(constant.MANAGEQUESTION.replace(":id", questionId.toString()), {
      state: { questionIdToEdit: questionId },
    });
  };

  useEffect(() => {
    if (isLoaded && !isFilter) {
      bindQuestionList();
    }
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1 && !isFilter && !isLoaded) {
      setIsLoaded(true);
    } else {
      bindQuestionList();
    }
  }, [pageSize]);

  useEffect(() => {
    bindStateData();
    subjectByStateId();
  }, []);

  useEffect(() => {
    if (subjectId) {
      domainBySubjectId();
    }
    if (domainId) {
      standardByDomainId();
    }
  }, [subjectId, domainId]);

  useEffect(() => {
    if (isLoaded) {
      bindQuestionList();
    }
  }, [sortAscending]);

  useEffect(() => {
    if (!isReset && isLoaded) {
      bindQuestionList(true);
      setIsFilter(true);
      setFilterClicked(true);
    }
  }, [selectedTagIds]);

  function handleSort(columnName) {
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
  }

  const subjectByStateId = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getSubjectByState(
      99999,
      pageNumber,
      stateId,
      true,
      true
    );
    const data = (await response).data;
    const options = data.data.map((item) => {
      return {
        label: item.name,
        value: item.subjectId,
      };
    });
    setSubjects(options);
  };

  const bindStateData = async () => {
    const service = await import("../../../api/subject.service");
    const response = service.getStateAll(99999, pageNumber);
    const data = (await response).data;
    const options = data.data.map((item) => {
      return {
        label: item.name,
        value: item.stateId,
      };
    });
    setState(options);
  };

  function standardByDomainId() {
    setLoading(true);

    const standard: IStandard = {
      name: "",
      contentAreaId: "",
      subjectId: "",
      domainId: domainId + "",
      code: "",
      isActive: true,
      isApproved: true,
      description: "",
      loadOrder: 0,
      pageSize: 99999,
      pageNumber: pageNumber,
      orderbyColumn: "Name",
      sortDir: "ASC",
    };
    getStandards(standard).then((response: any) => {
      setLoading(false);
      const options = response.data.data.map((item) => {
        return {
          label: `(${item.code}) ${item.name}`,
          value: item.standardId,
        };
      });
      setStandard(options);
    });
  }

  const domainBySubjectId = () => {
    getAllDomainsBySubject(subjectId, 99999, pageNumber).then((res) => {
      const options = res.data.data.map((item) => {
        return {
          label: item.name,
          value: item.domainId,
        };
      });
      setDomain(options);
    });
  };

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    const numericExpression = new RegExp(/^[0-9.,]*$/);
    const input = document.getElementById("questionId");

    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!numericExpression.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }
  }, []);

  function handleFilterQuestionIdChange(e: any) {
    setFilterQuestionId(e.target.value);
  }

  function redirectToDomainDetail(domainId) {
    navigate(constant.EDITDOMAIN.replace(":id", domainId.toString()));
  }
  function redirectToSubjectDetail(subjectId) {
    navigate(constant.SUBJECTDETAIL.replace(":id", subjectId.toString()));
  }
  function redirectToStandardDetail(standardId) {
    navigate(constant.EDITSTANDARD.replace(":id", standardId.toString()));
  }

  const onAssociateCheckbox = (checked, questionId) => {
    const ds = associateQuestions;
    if (checked) {
      if (associateQuestions.length) {
        if (!associateQuestions.includes(questionId)) {
          ds.push(questionId);
          setAssociateQuestions(ds);
        } else {
          setAssociateQuestions(ds);
        }
      } else if (checked) {
        setAssociateQuestions([questionId]);
      }

      for (let i = 0; i < associateQuestions.length; i++) {
        const elem: any = document.getElementById(`${questionId}`);
        if (elem) elem.checked = true;
      }
    }

    if (checked === false) {
      let removedUnchecked: any = [];
      removedUnchecked = ds.filter((d) => d !== questionId);
      setAssociateQuestions(removedUnchecked);
      const elem: any = document.getElementById(`${questionId}`);
      if (elem) elem.checked = false;
    }
  };

  const associateStandardQues = async () => {
    if (parameters && parameters.associateStandardId) {
      validateStandardQuestionAssociation(
        associateQuestions.join(","),
        parameters.associateStandardId
      ).then(async (d) => {
        if (d.data.isValid === true) {
          await associateStandardQuestions({
            standardId: parameters.associateStandardId,
            questionIds: associateQuestions,
          });

          navigate(
            constant.EDITSTANDARD.replace(
              ":id",
              parameters.associateStandardId.toString()
            ),
            {
              state: {
                idToEdit: parameters.associateStandardId,
                fromAssociatedPage: true,
              },
            }
          );
        } else {
          let message = "<ul class='list-disc'>";
          d.data.linkedQuestions.forEach((msg) => {
            message = message + "<li class='mt-2'>" + msg + "</li>";
          });
          message = message + "</ul>";
          confirm({
            variant: "info",
            title: "Questions already associated",
            description: message,
          });
        }
      });
    } else {
      const module = await import("react-toastify");
      module.toast.warning("Unable to find standard id, please retry");
    }
  };

  const handleFilterTags = (tags) => {
    setIsResetFlag(false);
    const selectedTagIds = tags
      .filter((tag) => tag.selected === true)
      .map((tag) => tag.tagId);
    setSelectedTagIds(selectedTagIds);
  };

  const handleTagClick = (tag) => {
    setIsResetFlag(false);
    setSelectedTagIds([tag.tagId]);
  };

  const handleUntagged = () => {
    setIsResetFlag(false);
    setSelectedTagIds([]);
  };

  const copyQuestionIds = () => {
    if (filterQuestionId) {
      setFilterQuestionId(0);
    } else {
      let LS: any = localStorage.getItem("clipboard");
      if (LS) {
        LS = JSON.parse(LS);
        setFilterQuestionId(LS?.items);
      }
    }
  };

  const selectAllQuestions = (checked) => {
    questionList.forEach((q) => {
      onAssociateCheckbox(checked, q.questionId);
    });
  };
  return (
    <Fragment>
      {loading && <Loader />}

      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between pb-4">
              <h3 className="text-lg font-light text-gray-900">
                Associate Questions{" "}
                {parameters.associateStandardName?.length > 0
                  ? "To [" + parameters.associateStandardName + "]"
                  : ""}
              </h3>
            </div>
            <div className={"pt-6"}>
              <div className={"grid grid-cols-12 gap-5 border-b pb-6"}>
                <div className={"col-span-3"}>
                  <div className="flex justify-betweentext-sm text-gray-700">
                    Question Ids{" "}
                    <CopyIcon
                      onClick={() => copyQuestionIds()}
                      title="Paste from clipboard"
                    />
                  </div>
                  <input
                    id="questionId"
                    name="questionId"
                    type="text"
                    autoComplete="off"
                    className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    value={filterQuestionId || ""}
                    onChange={handleFilterQuestionIdChange}
                  />
                </div>

                <div className="col-span-3">
                  <div className="text-sm text-gray-700">Question Type</div>
                  <div className="mt-1 text-sm">
                    <QuestionTypeSelect
                      onChange={handleQuestionTypeChange}
                      value={questionTypeId}
                    ></QuestionTypeSelect>
                  </div>
                </div>

                <div className={"col-span-3 ..."}>
                  <div className="text-sm text-gray-700"> State</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"stateList"}
                      dropValue={state}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleStateChange}
                      enableDisableSubjects={setEnableDisableSubjects}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className={"text-sm text-gray-700"}>Subject</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"subjectList"}
                      dropValue={subjects}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={selectedSubject || ""}
                      dropSelect={handleSubjectChange}
                      enableDisableDomains={setEnableDisableDomains}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Domain</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"domainList"}
                      dropValue={domain}
                      defaultValue={selectedDomain || ""}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={handleDomainChange}
                      enableDisableStandards={setEnableDisableStandards}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">Standard</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"standardList"}
                      dropValue={standard}
                      defaultValue={selectedStandard || ""}
                      resetDropdown={resetDropdownFlag}
                      dropSelect={handleStandardChange}
                      questionId={questionId}
                      setQuestionId={setQuestionId}
                    ></DropDownComponent>
                  </div>
                </div>

                <div className={"col-span-3"}>
                  <div className="text-sm text-gray-700">DOK</div>
                  <div className="mt-1 text-sm">
                    <DropDownComponent
                      dropName={"dokList"}
                      dropValue={constant.DOK}
                      resetDropdown={resetDropdownFlag}
                      defaultValue={""}
                      dropSelect={handleDOKChange}
                    ></DropDownComponent>
                  </div>
                </div>
                <div className={"col-span-1 flex items-end"}>
                  <label className="flex items-center">
                    <input
                      id="active"
                      name="isActive"
                      type="checkbox"
                      checked={isActive}
                      onChange={() => setIsActive(!isActive)}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <span className="ml-2 dark:text-white">Active</span>
                  </label>
                </div>
                <div className={"col-span-1 flex items-end"}>
                  <label className="flex items-center">
                    <input
                      id="active"
                      name="isPublished"
                      type="checkbox"
                      checked={isPublished}
                      onChange={() => setIsPublished(!isPublished)}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <span className="ml-2 dark:text-white">Published</span>
                  </label>
                </div>
                <div className={"col-span-1 flex items-end"}>
                  <label className="flex items-center">
                    <input
                      id="active"
                      name="isDiagnostic"
                      type="checkbox"
                      checked={isDiagnostics}
                      onChange={() => setIsDiagnostics(!isDiagnostics)}
                      className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                    />
                    <span className="ml-2 dark:text-white">Diagnostic</span>
                  </label>
                </div>
                <div className="col-span-1 flex items-end">
                  <div className="flex items-center contentArea">
                    <TagSelector
                      label={"Tags"}
                      onTagSelectChange={(tags) => {
                        handleFilterTags(tags);
                      }}
                      onFilterUntagged={() => {
                        handleUntagged();
                      }}
                      removeTag={(tags, tag) => {
                        handleFilterTags(tags);
                      }}
                      mode={TagSelectorMode.Filter}
                      categoryId={0}
                      selectedTagIds={selectedTagIds}
                    />
                  </div>
                </div>
              </div>

              <div className="flex mt-4 items-center justify-between">
                <div>
                  <button
                    type="submit"
                    className="mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                    onClick={() => {
                      setFilterClicked(true);
                      bindQuestionList(true);
                    }}
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>Filter</span>
                  </button>
                  <button
                    type="button"
                    className="mt-4 py-1.5 px-4 inline-flex ml-3 items-center text-sm rounded-lg text-gray-700 text-primary-color border border-gray-300 gap-2 bg-white hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color "
                    onClick={() => resetFilterHandler()}
                  >
                    <ResetIcon className="w-3 h-3"></ResetIcon>
                    <span>Reset Filter</span>
                  </button>
                </div>

                <div
                  className={`${
                    associateQuestions.length === 0 ? "cursor-not-allowed" : ""
                  } flex space-x-4 dark:text-white`}
                >
                  <button
                    type="button"
                    className={`${
                      associateQuestions.length === 0
                        ? "pointer-events-none opacity-50"
                        : ""
                    } mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg`}
                    onClick={() => associateStandardQues()}
                  >
                    <span>Associate Questions</span>
                  </button>
                </div>
              </div>
            </div>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                              <label className="flex items-center mr-2">
                                <input
                                  name="selectAll"
                                  type="checkbox"
                                  onChange={(e) => {
                                    selectAllQuestions(e.target.checked);
                                  }}
                                  className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                />
                              </label>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider w-32"
                            >
                              <span className="flex gap-2">
                                Id
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "QuestionId" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("QuestionId")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("QuestionId")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                            >
                              <span className="flex gap-2">
                                Question
                                <span className="cursor-pointer">
                                  {!sortAscending &&
                                  orderByColumn === "questionText" ? (
                                    <CaretUpSolidIcon
                                      onClick={() => handleSort("questionText")}
                                      className="w-5 h-5"
                                    ></CaretUpSolidIcon>
                                  ) : (
                                    <CaretDownSolidIcon
                                      onClick={() => handleSort("questionText")}
                                      className="w-5 h-5"
                                    ></CaretDownSolidIcon>
                                  )}
                                </span>
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">Classification</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">DOK</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">Exp</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">
                                Machine translated
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">
                                Human translated
                              </span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white"
                            >
                              <span className="flex gap-2">Published</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {questionList.map((question, index) => {
                            const questionId: any = question.questionId;
                            return (
                              <Fragment key={index}>
                                <tr
                                  key={question.questionId}
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                  }
                                >
                                  <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                    <label className="flex items-center mr-2">
                                      <input
                                        id={questionId}
                                        name="isActive"
                                        type="checkbox"
                                        onChange={(e) =>
                                          onAssociateCheckbox(
                                            e.target.checked,
                                            question.questionId
                                          )
                                        }
                                        className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                                      />
                                    </label>
                                  </td>
                                  <td className="px-3 py-2 pl-6  text-sm text-left font-normal text-gray-500 relative">
                                    <div className="flex">
                                      <div className="flex">
                                        <Link
                                          className="pl-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                          to={constant.MANAGEQUESTION.replace(
                                            ":id",
                                            question.questionId!.toString()
                                          )}
                                        >
                                          {question.questionId}
                                        </Link>
                                        <UgaItemIcon
                                          externalSourceTypeId={
                                            question.externalSourceTypeId
                                          }
                                          className="ml-1.5 self-center"
                                        />
                                      </div>
                                    </div>
                                  </td>
                                  <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    <a
                                      className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                      onClick={(e) => {
                                        editHandler(question.questionId);
                                      }}
                                    >
                                      <Tooltip
                                        text={
                                          question?.questionText === null
                                            ? question?.questionText
                                            : question?.questionText
                                        }
                                        length={100}
                                      />
                                    </a>
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    {question.questionClassification}
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                                    {question.dok}
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-center font-normal">
                                    <div className="flex items-center">
                                      {question.settings?.filter((e) => {
                                        return e.videoExplanation !== undefined;
                                      })[0]?.videoExplanation && (
                                        <span className="relative w-11 inline-block">
                                          <VideoIcon
                                            className="w-4 h-4"
                                            title="Video explanation available for this subject"
                                          />{" "}
                                        </span>
                                      )}
                                    </div>
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-center font-normal">
                                    {!question?.isHumanTranslated ? (
                                      <ApproveIcon />
                                    ) : (
                                      <Disapprove />
                                    )}
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-center font-normal">
                                    {question?.isHumanTranslated ? (
                                      <ApproveIcon />
                                    ) : (
                                      <Disapprove />
                                    )}
                                  </td>
                                  <td className="px-3 py-2 whitespace-wrap text-sm text-center font-normal">
                                    {question?.isPublished ? (
                                      <ApproveIcon title="Approved" />
                                    ) : (
                                      <Disapprove />
                                    )}
                                  </td>
                                </tr>
                                <tr
                                  className={
                                    index % 2 === 0 ? "bg-white" : "bg-gray-100"
                                  }
                                >
                                  <td className="pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500 relative">
                                    {question.isActive ? (
                                      <span className="mr-1 mb-2 h-full w-0.5 bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                    ) : (
                                      <span className="mr-1 mb-2 h-full w-0.5 bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                                    )}
                                  </td>
                                  <td colSpan={10}>
                                    {question?.tags?.map((tag) => (
                                      <li
                                        key={tag.tagId}
                                        className={`inline-block bg-[${
                                          tag.color
                                        }] 
                                rounded-full text-xs shadow-sm py-0.5 px-3  whitespace-nowrap mx-1 mb-2 cursor-pointer
                               ${
                                 TagColor.isDark(tag.color)
                                   ? "text-white"
                                   : "text-black"
                               }
                                `}
                                        onClick={() => {
                                          handleTagClick(tag);
                                        }}
                                      >
                                        {tag.name}
                                      </li>
                                    ))}
                                  </td>
                                </tr>
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                      {questionList.length === 0 && (
                        <p className="p-2">No Records Found</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="flex justify-between items-center">
                  {questionList.length !== 0 ? (
                    <>
                      <Pagination
                        pages={totalPages}
                        setPageNumber={setPageNumber}
                        ref={paginationRef}
                      />
                      <span>
                        <span className="text-sm pr-4 ml-auto text-left-700">
                          Showing {pageNumber} to{" "}
                          {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                          {totalRecords} results
                        </span>

                        <SelectPageSize
                          setPageSize={setPageSize}
                          type={"second"}
                          ref={pageSizeRef}
                          defaultPage={pageSize}
                        />
                      </span>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default QuestionList;
